import { useEffect, useState } from "react";

// true ab Desktop-Breite (Default xl = 1280px). Darunter (Tablet/Handy) false.
export function useIsDesktop(bp = 1280) {
  const [isDesktop, setIsDesktop] = useState(
    () => typeof window !== "undefined" && window.innerWidth >= bp
  );
  useEffect(() => {
    const mq = window.matchMedia(`(min-width:${bp}px)`);
    const on = () => setIsDesktop(mq.matches);
    on();
    mq.addEventListener("change", on);
    return () => mq.removeEventListener("change", on);
  }, [bp]);
  return isDesktop;
}
